import React, { useState, useEffect, useCallback, useRef } from 'react';
import {
   Modal,
   ModalOverlay,
   ModalContent,
   ModalHeader,
   ModalFooter,
   ModalBody,
   ModalCloseButton,
   Button,
   Grid,
   GridItem,
   useColorModeValue,
   Flex,
   Box,
} from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import { renderDynamicDropdown } from '../../../../../components/UIcomponents/DynamicDropdown';
import InputField from 'components/ui/InputField';
import moment from 'moment';
import { splitPayload } from 'utils/saleUtility';
import calculateTaxAmount from 'utils/saleUtility';

import { getAllDaybooks } from '../../../../../redux/actions/daybook';
import { useUser, useGlobal } from '../../../../../contexts';
import useIssueLastDaybook from '../../../../../hooks/useIssueLastDaybook';
import { addManyIssueInventory } from '../../../../../redux/actions/issueInventory';
import { useNavigate } from 'react-router-dom';

const IssueToMill = ({ isOpen, onClose, brokerData, issueData }) => {
   const dispatch = useDispatch();
   const navigate = useNavigate();
   // const rows
   const daybookData = useSelector((state) => state.daybook?.allDaybooks || []);
   const billTermData = useSelector((state) => state.billTerm?.list);
   const itemData = useSelector((state) => state.item?.list ?? []);
   const { user } = useUser();
   const { company } = useGlobal();
   const { lastDaybook, setSelectedDaybookId: setDaybookId } = useIssueLastDaybook();

   const [rows, setRows] = useState({
      daybookId: lastDaybook?.daybookId ?? '',
      noofchallan: 1,
      challanno: '',
      issueAt: moment().local().format('YYYY-MM-DD'),
      millId: null,
      orderId: null,
      brokerId: null,
      jobrate: '',
      remarks: '',
   });

   const clearFormData = () => {
      setRows({
         daybookId: null,
         noofchallan: '',
         challanno: '',
         issueAt: '',
         millId: null,
         orderId: 0,
         brokerId: null,
         jobrate: '',
         remarks: '',
      });
   };

   const orderData = [
      { label: 'Normal', value: 0, id: 0 },
      { label: 'Ascending', value: 1, id: 1 },
      { label: 'Descending ', value: 2, id: 2 },
   ];

   const [isLoading, setIsLoading] = useState(false);
   const textColor = useColorModeValue('gray.800', 'white');
   const submitRef = useRef(null);
   const daybookRef = useRef(null);
   const docNoRef = useRef(null);
   const transactionAtRef = useRef(null);
   const saveRef = useRef(null);
   const remarksRef = useRef(null);
   const jobrateRef = useRef(null);
   const brokerRef = useRef(null);
   const orderRef = useRef(null);
   const challanNoRef = useRef(null);
   const millRef = useRef(null);
   // const orderRef = useRef(null);
   // const challanNoRef = useRef(null);

   const handleOnClose = () => {
      clearFormData();
      onClose();
   };

   const handleSave = async () => {
      const payload = {
         header: {
            basicAmount: issueData?.basicAmount ?? 0,
            voucherId: 0,
            netAmount: issueData?.netAmount,
            companyId: Number(user?.loginhistory?.companyId),
            accountId: rows?.millId,
            daybookId: rows?.daybookId,
            additionAmount: issueData?.additionAmount,
            deductionAmount: issueData?.deductionAmount,
            dueDays: issueData?.dueDays,
            transactionAt: moment(rows?.issueAt).format('YYYY-MM-DD'),
            dueAt: moment(issueData?.dueAt).format('YYYY-MM-DD'),
            gstAmount: issueData?.gstAmount,
            warehouseId: issueData?.warehouseId,
            taxableAmount: issueData?.taxableAmount,
            billtoStateId: issueData?.billtoStateId,
            shiptoStateId: issueData?.shiptoStateId,
            gstTxnType: 0,
            gstSubTxnType: 0,
            assesseType: 0,
            distance: 0,
            brokerId: rows.brokerId ?? null,
            notes: null,
            transportId: null,
            vehicleId: null,
            representativeId: issueData?.representativeId,
         },

         lineItem: issueData.lineitems?.map((item) => {
            const selectedItem = itemData?.find((i) => i.id.toString() === item.itemId?.toString());
            const takaDetails =
               rows.orderId === 1
                  ? item.purchaseLineDetail.sort((a, b) => (a.quantity3 ?? 0) - (b.quantity3 ?? 0))
                  : rows.orderId === 2
                  ? item.purchaseLineDetail.sort((a, b) => (b.quantity3 ?? 0) - (a.quantity3 ?? 0))
                  : item.purchaseLineDetail;

            return {
               // ...(item.id && { id: item.id }),
               typeOfSupply: item.typeOfSupply ? item.typeOfSupply : 1,
               itemId: item.itemId ? Number(item.itemId) : 0,
               lineNumber: item.lineNumber ? Number(item.lineNumber) : 1,
               itemRate: rows.jobrate ? Number(rows.jobrate) : 0,
               amount: item.amount ? Number(item.amount) : 0,
               netAmount: item.netAmount ? Number(item.netAmount) : 0,
               ratePer: selectedItem?.rateperpurchaseid ? Number(selectedItem?.rateperpurchaseid) : 0,
               uomNoForRate:
                  selectedItem?.uqcid1 === selectedItem?.rateperpurchaseid
                     ? 1
                     : selectedItem?.uqcid2 === selectedItem?.rateperpurchaseid
                     ? 2
                     : selectedItem?.uqcid3 === selectedItem?.rateperpurchaseid
                     ? 3
                     : 1,
               qUnitId1: selectedItem?.uqcid1,
               qUnitId2: selectedItem?.uqcid2,
               qUnitId3: selectedItem?.uqcid3,
               qty1: item.qty1 ? Number(item.qty1 ?? 0) : 0,
               qty2: item.qty2 ? Number(item.qty2 ?? 0) : 0,
               qty3: item.qty3 ? Number(item.qty3 ?? 0) : 0,
               addLess1Percent: item.addLess1Percent ? Number(item.addLess1Percent) : 0,
               addLess1Amount: item.addLess1Amount ? item.addLess1Amount : 0,
               addLess2Percent: item.addLess2Percent ? Number(item.addLess2Percent) : 0,
               addLess2Amount: item.addLess2Amount ? item.addLess2Amount : 0,
               addLess3Percent: item.addLess3Percent ? Number(item.addLess3Percent) : 0,
               addLess3Amount: item.addLess3Amount ? item.addLess3Amount : 0,
               taxableAmount: item.taxableAmount ? item.taxableAmount : 0,
               netGst: item.netGst ? item.netGst : 0,
               gstPercent: item.gst ? item.gst : 0,
               cgst: 0,
               sgst: 0,
               igst: 0,
               stock: item.stock?.length > 0 ? item.stock : [],
               takaDetails: takaDetails?.length > 0 ? takaDetails : [],
               hsnId: selectedItem?.hsnid,
               sacId: selectedItem?.sacid,
            };
         }),
         billTerm: [],
      };

      let data = [];
      if (rows.noofchallan > 1) {
         data = splitPayload(payload, rows.noofchallan);
      }
      if (rows.noofchallan === 0 || rows.noofchallan === 1) {
         data = [payload];
      }

      const iData = data.map((item, idx) => {
         item.header.docno = `${Number(rows.challanno) + idx}`;
         const payload = calculateTaxAmount(item, {
            company: company,
            user: user,
            itemData: itemData,
            billTermData: billTermData,
            daybookData: daybookData,
         });
         return payload.data;
      });

      await dispatch(addManyIssueInventory(iData));

      clearFormData();
      handleOnClose();
      navigate('/admin/purchase/invoice');
   };

   const handleChange = async (name, value) => {
      setRows((prev) => ({
         ...prev,
         [name]: value,
      }));
   };

   const handleKeyDown = (e, nextRef, preRef) => {
      if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
         e.preventDefault();
         if (nextRef && nextRef?.current) {
            nextRef?.current?.focus();
         }
      }
      if (e.key === 'Tab' && e.shiftKey) {
         e.preventDefault();
         if (preRef && preRef?.current) {
            preRef?.current?.focus();
         }
      }
   };

   const setChallanNumber = useCallback(async () => {
      if (isOpen && lastDaybook && lastDaybook.docno) {
         const currentDocNo = String(lastDaybook.docno ?? 0);
         const nextDocNo = (parseInt(currentDocNo) + 1).toString() ?? '1';
         setRows((prev) => ({
            ...prev,
            daybookId: lastDaybook?.daybookId,
            challanno: nextDocNo,
         }));
      } else {
         setRows((prev) => ({
            ...prev,
            challanno: '1',
         }));
      }
   }, [isOpen, lastDaybook]);

   useEffect(() => {
      setTimeout(() => {
         daybookRef.current?.focus();
      }, 100); // small delay sometimes helps
   }, [isOpen]);

   useEffect(() => {
      if (isOpen && user) {
         dispatch(getAllDaybooks({ type: 19, companyId: user.loginhistory.companyId }));
      }
   }, [dispatch, isOpen, user]);

   useEffect(() => {
      setChallanNumber();
   }, [setChallanNumber]);

   return (
      <>
         <Modal isOpen={isOpen} onClose={handleOnClose} size="6xl" isCentered>
            <ModalOverlay />
            <ModalContent
               bg={useColorModeValue('white', '#2d3748')}
               color={useColorModeValue('gray.800', 'white')}
               borderRadius="20px"
               p={5}
               boxShadow="lg">
               <ModalHeader fontSize="20px" fontWeight="600" pt={0} pb={3} px={2}>
                  Issue To Mill
               </ModalHeader>
               <ModalCloseButton />
               <ModalBody p={0}>
                  <Box w="auto" p={4} borderRadius="md" shadow="sm" border="1px solid gray">
                     <Grid gap={3} templateColumns="repeat(3, 1fr)">
                        <GridItem w="100%">
                           {renderDynamicDropdown(
                              'daybookId',
                              'Daybook',
                              daybookData.filter((item) => item.type === 19),
                              {
                                 errorName: 'header.daybookId',
                                 value: rows.daybookId,
                                 onChange: (value) => handleChange('daybookId', value),
                                 focusBorderColor: 'blue.500',
                                 _focus: {
                                    boxShadow: '0 0 0 3px rgba(66, 153, 225, 0.6)',
                                 },
                                 ref: daybookRef,
                                 nextRef: docNoRef,
                                 showCustomNoOptions: true,
                                 openfrom: 'salesdaybook',
                              },
                              {},
                              textColor,
                              false,
                              'Select Daybook',
                           )}
                        </GridItem>
                        <GridItem w="100%">
                           <InputField
                              ref={docNoRef}
                              type="text"
                              name="noofchallan"
                              label="Nos. of Challan"
                              value={rows.noofchallan}
                              onChange={(e) => handleChange('noofchallan', e.target.value)}
                              onKeyDown={async (e) => {
                                 handleKeyDown(e, transactionAtRef, daybookRef);
                              }}
                              // autoFocus={id > 0 ? true : false}
                           />
                        </GridItem>
                        <GridItem w="100%">
                           <InputField
                              ref={transactionAtRef}
                              type="date"
                              name="issueAt"
                              label="Issue Date"
                              value={rows.issueAt}
                              onChange={(e) => handleChange('issueAt', e.target.value)}
                              onKeyDown={(e) => handleKeyDown(e, millRef, docNoRef)}
                           />
                        </GridItem>
                        <GridItem w="100%">
                           {renderDynamicDropdown(
                              'millId',
                              'Mill',
                              brokerData,
                              {
                                 errorName: 'header.millId',
                                 value: rows.millId,
                                 onChange: (value) => handleChange('millId', value),
                                 focusBorderColor: 'blue.500',
                                 _focus: {
                                    boxShadow: '0 0 0 3px rgba(66, 153, 225, 0.6)',
                                 },
                                 ref: millRef,
                                 nextRef: challanNoRef,
                                 prevRef: transactionAtRef,
                                 showCustomNoOptions: true,
                                 openfrom: 'account',
                              },
                              {},
                              textColor,
                              false,
                              'Select Daybook',
                           )}
                        </GridItem>
                        <GridItem w="100%">
                           <InputField
                              ref={challanNoRef}
                              type="text"
                              name="challanno"
                              label="Challan Number"
                              value={rows.challanno}
                              onChange={(e) => handleChange('challanno', e.target.value)}
                              onKeyDown={async (e) => {
                                 handleKeyDown(e, orderRef, millRef);
                              }}
                              // autoFocus={id > 0 ? true : false}
                           />
                        </GridItem>
                        <GridItem w="100%">
                           {renderDynamicDropdown(
                              'orderId',
                              'Take order',
                              orderData,
                              {
                                 errorName: 'header.orderId',
                                 value: rows.orderId,
                                 onChange: (value) => handleChange('orderId', value),
                                 focusBorderColor: 'blue.500',
                                 _focus: {
                                    boxShadow: '0 0 0 3px rgba(66, 153, 225, 0.6)',
                                 },
                                 ref: orderRef,
                                 nextRef: brokerRef,
                                 prevRef: challanNoRef,
                              },
                              {},
                              textColor,
                              false,
                              'Select Daybook',
                           )}
                        </GridItem>
                        <GridItem w="100%">
                           {renderDynamicDropdown(
                              'brokerId',
                              'Broker',
                              brokerData,
                              {
                                 errorName: 'header.brokerId',
                                 value: rows.brokerId,
                                 onChange: (value) => handleChange('brokerId', value),
                                 focusBorderColor: 'blue.500',
                                 _focus: {
                                    boxShadow: '0 0 0 3px rgba(66, 153, 225, 0.6)',
                                 },
                                 ref: brokerRef,
                                 nextRef: jobrateRef,
                                 prevRef: orderRef,
                                 showCustomNoOptions: true,
                                 openfrom: 'account',
                              },
                              {},
                              textColor,
                              false,
                              'Select Daybook',
                           )}
                        </GridItem>
                        <GridItem w="100%">
                           <InputField
                              ref={jobrateRef}
                              type="text"
                              name="jobrate"
                              label="Job Rate"
                              value={rows.jobrate}
                              onChange={(e) => handleChange('jobrate', e.target.value)}
                              onKeyDown={async (e) => {
                                 handleKeyDown(e, remarksRef, brokerRef);
                              }}
                              // autoFocus={id > 0 ? true : false}
                           />
                        </GridItem>
                        <GridItem w="100%">
                           <InputField
                              ref={remarksRef}
                              type="text"
                              name="remarks"
                              label="Remarks"
                              value={rows.remarks}
                              onChange={(e) => handleChange('remarks', e.target.value)}
                              onKeyDown={async (e) => {
                                 handleKeyDown(e, submitRef, jobrateRef);
                              }}
                              // autoFocus={id > 0 ? true : false}
                           />
                        </GridItem>
                     </Grid>
                  </Box>
               </ModalBody>
               <ModalFooter justifyContent="flex-end" alignItems="center" pb={0} pr={0}>
                  <Flex>
                     <Button
                        ref={submitRef}
                        colorScheme="blue"
                        ml={3}
                        width="100%"
                        onClick={() => handleSave()}
                        _focus={{ outlineColor: 'blue.500' }}
                        isDisabled={isLoading}
                        isLoading={isLoading}>
                        Save
                     </Button>
                     <Button colorScheme="red" onClick={() => handleOnClose()} ml={3} width="100%">
                        Cancel
                     </Button>
                  </Flex>
               </ModalFooter>
            </ModalContent>
         </Modal>
      </>
   );
};

export default IssueToMill;
